import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const GrossSalaryCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [netSalary, setNetSalary] = useState('4.000,00');
  const [discountRate, setDiscountRate] = useState('25,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const net = parseFloat(parseBrazilianNumber(netSalary)) || 0;
    const d = parseFloat(parseBrazilianNumber(discountRate)) / 100;
    if (net <= 0 || d <= 0 || d >= 1) return;

    const grossValue = net / (1 - d);
    const discountsAmount = grossValue - net;

    const res = { net, gross: grossValue, discounts: discountsAmount, discountRate: d * 100 };
    setResultState(res);

    onResultChange([
      { label: 'Salário Líquido', value: `R$ ${net.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Bruto Estimado', value: `R$ ${grossValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Descontos Totais', value: `R$ ${discountsAmount.toLocaleString('pt-BR', { minimumFractionDigits: 2 })} (${(d * 100).toFixed(1)}%)` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Salário Líquido (R$)" value={netSalary} onChange={setNetSalary} required isNumeric type="text" />
          <FormField label="Descontos Totais (%)" value={discountRate} onChange={setDiscountRate} required isNumeric type="text" helpText="Estimativa: INSS + IRPF + outros" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Bruto
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Bruto (estimado)" value={`R$ ${resultState.gross.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
            <ResultCard title="Descontos" value={`R$ ${resultState.discounts.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Líquido" value={`R$ ${resultState.net.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="emerald" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Entendendo Salário Bruto e Líquido"
        tips={[
          'Salário Bruto: Valor nominal registrado em carteira',
          'Salário Líquido: O que cai na conta após descontos obrigatórios',
          'Principais descontos: INSS (previdência) e IRPF (imposto de renda)',
          'Algumas empresas oferecem benefícios que também podem ser descontados (ex: VR, VT)'
        ]}
      />
    </div>
  );
};

export default GrossSalaryCalculator;
